"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ERROR_CODES = void 0;
const error_codes_announcements_1 = require("./error-codes-announcements");
const error_codes_post_event_1 = require("./error-codes-post-event");
/**
 * API dile bağımlı serbest metin döndürmez (Story 0.3).
 * Sunucu bir hata KODU döner, istemci `errors.<code>` anahtarıyla çevirir.
 *
 * Kod eklerken `packages/shared/src/i18n/locales/{tr,en}.ts` içindeki `errors`
 * bloğuna da eklenmelidir — eksik anahtar derlemeyi kırar.
 */
exports.ERROR_CODES = {
    // Genel
    INTERNAL_ERROR: 'INTERNAL_ERROR',
    VALIDATION_FAILED: 'VALIDATION_FAILED',
    NOT_FOUND: 'NOT_FOUND',
    CONFLICT: 'CONFLICT',
    RATE_LIMITED: 'RATE_LIMITED',
    PAYLOAD_TOO_LARGE: 'PAYLOAD_TOO_LARGE',
    UNSUPPORTED_MEDIA_TYPE: 'UNSUPPORTED_MEDIA_TYPE',
    /**
     * KİŞİSEL VERİ GÖRÜNTÜLEME İZİ YAZILAMADI (kullanıcı kararı 15.10.2026, C21):
     * iz yoksa veri de yok. 503 döner, çünkü arıza geçicidir (denetim defterine
     * ulaşılamıyor) ve istek aynen tekrarlanabilir; istemci var olan hata hâlini
     * ve "tekrar dene"yi çizer. Politika `apps/api/src/modules/audit/personal-data-access.ts`.
     */
    AUDIT_UNAVAILABLE: 'AUDIT_UNAVAILABLE',
    /**
     * SUNUCU YÜK ATIYOR (yük testi 20.10.2026): işçinin eşzamanlı istek tavanı
     * doldu, istek kuyrukta beklerken süre aştı ya da veritabanı havuzundan
     * bağlantı/sorgu süresi doldu. 503 + `Retry-After` döner; istek aynen
     * tekrarlanabilir. Kaynak: `apps/api/src/common/middleware/load-shedding.middleware.ts`.
     */
    SERVICE_OVERLOADED: 'SERVICE_OVERLOADED',
    // Kimlik / yetki
    UNAUTHENTICATED: 'UNAUTHENTICATED',
    TOKEN_EXPIRED: 'TOKEN_EXPIRED',
    TOKEN_INVALID: 'TOKEN_INVALID',
    // Koruyucu iptal edilmiş oturumu reddetti (sıra 45): istemci bir kez yeniler.
    // `TOKEN_INVALID` yenileme ucunun kararıdır. Envanter: session-code-inventory.guard.spec.
    SESSION_REVOKED: 'SESSION_REVOKED',
    FORBIDDEN: 'FORBIDDEN',
    ACCOUNT_SUSPENDED: 'ACCOUNT_SUSPENDED',
    ACCOUNT_DELETED: 'ACCOUNT_DELETED',
    /**
     * HESAP KİTLESİ KAPISI (kullanıcı kararı 02.10.2026 · Story H3). Kurum hesabı
     * katılımcı ucuna (kayıt, kart, cüzdan, keşif, görüşme…) ya da kişisel hesap
     * yönetim ucuna (kurum, ekip, kredi, etkinlik yönetimi, kapı) geldi. Kişisel
     * hesabın yönetim ucundan reddi `nextAction: 'contact_sales'` taşır (KH5).
     */
    ACCOUNT_KIND_NOT_ALLOWED: 'ACCOUNT_KIND_NOT_ALLOWED',
    // OTP (Story 1.1) — kod hatalı/bulunamadı ayrımı SIZDIRILMAZ, ikisi de OTP_INVALID.
    OTP_INVALID: 'OTP_INVALID',
    OTP_EXPIRED: 'OTP_EXPIRED',
    OTP_ATTEMPTS_EXCEEDED: 'OTP_ATTEMPTS_EXCEEDED',
    /*
     * ÜRÜNÜN `PANEL_*` HATA KODLARI SİLİNDİ (panel kimliği ayrımı · S3):
     * `PANEL_CREDENTIALS_INVALID` · `PANEL_PASSWORD_MISMATCH` ·
     * `PANEL_PASSWORD_REUSED` · `PANEL_VERIFICATION_REQUIRED`.
     *
     * Dördü de `users` tablosuna dayanan eski panel yolunundu ve o yol söküldü.
     * Karşılıkları `STAFF_*` kodlarıdır ve aşağıda dururlar; `PANEL_*` adını
     * bırakmak, sözlükte hiçbir sunucu yolunun üretmediği dört ölü anahtar
     * bırakmak olurdu.
     */
    /**
     * PERSONEL KİMLİĞİ (panel kimliği ayrımı · S1). Ürünün `PANEL_*` kodlarından
     * AYRI: o kodlar `users` tablosuna dayanan ESKİ panel yolunundur ve S3'te
     * düşerler. Bu kodlar `staff_accounts` kimliğinindir.
     *
     * TEK GENEL HATA aynı ilkeyle korunur: adres yok · şifre yanlış · hesap
     * askıda/kapalı · şifre hiç kurulmamış → dördü de `STAFF_CREDENTIALS_INVALID`.
     */
    STAFF_CREDENTIALS_INVALID: 'STAFF_CREDENTIALS_INVALID',
    /** Bu kökene verilmiş canlı kod yanlış girildi. */
    STAFF_CODE_INVALID: 'STAFF_CODE_INVALID',
    /**
     * Bu kökene verilmiş canlı kod yok: hesap yok · kod yok · kod şifrenin
     * girildiği başka bir ağa bağlı (G1b). Üçü tek kod; kod karşılaştırılmaz,
     * ayrım sızdırılmaz. Panel şifre adımına döndürür.
     */
    STAFF_CODE_NETWORK_CHANGED: 'STAFF_CODE_NETWORK_CHANGED',
    STAFF_CODE_EXPIRED: 'STAFF_CODE_EXPIRED',
    STAFF_CODE_ATTEMPTS_EXCEEDED: 'STAFF_CODE_ATTEMPTS_EXCEEDED',
    /** Davet jetonu geçersiz, tüketilmiş, iptal edilmiş ya da süresi dolmuş. */
    STAFF_INVITATION_INVALID: 'STAFF_INVITATION_INVALID',
    /** Şifre değiştirme: mevcut şifre doğrulanamadı (oturum zaten açık). */
    STAFF_PASSWORD_MISMATCH: 'STAFF_PASSWORD_MISMATCH',
    /** Yeni şifre eskisinin aynısı — yazılmaz. */
    STAFF_PASSWORD_REUSED: 'STAFF_PASSWORD_REUSED',
    /** Hesap askıya alınmış ya da kapatılmış (oturumlu yüzeyde açıkça söylenir). */
    STAFF_ACCOUNT_SUSPENDED: 'STAFF_ACCOUNT_SUSPENDED',
    /** Aynı e-posta zaten bir personel hesabında (yalnız yönetici görür). */
    STAFF_EMAIL_TAKEN: 'STAFF_EMAIL_TAKEN',
    /** Adres `STAFF_EMAIL_DOMAINS` politikasının dışında (yalnız yönetici görür). */
    STAFF_EMAIL_DOMAIN_NOT_ALLOWED: 'STAFF_EMAIL_DOMAIN_NOT_ALLOWED',
    /** Personel oturumu gerekiyor — ürün jetonu panel ucunda geçmez. */
    STAFF_UNAUTHENTICATED: 'STAFF_UNAUTHENTICATED',
    /**
     * Personel oturumunun süresi doldu — ürünün `TOKEN_EXPIRED`ından AYRI
     * (QA S1 · P3-4). Panel istemcisi `STAFF_*` haritasıyla yazılır; ürün kodu
     * dönen bir personel yolu o haritanın dışına düşerdi ve ayrımın amacı buydu.
     */
    STAFF_SESSION_EXPIRED: 'STAFF_SESSION_EXPIRED',
    /** Personel oturumu var ama bu ucun yetkisi yok. */
    STAFF_FORBIDDEN: 'STAFF_FORBIDDEN',
    /**
     * ÜRÜN ŞİFRELİ GİRİŞİ — TEK GENEL HATA (kullanıcı kararı 05.09.2026 · K10).
     *
     * Dört durum AYNI kodu döner: e-posta yok · hesabın şifresi yok (yalnız kodla
     * giren eski hesap) · şifre yanlış · hesap kullanılamaz. Personelin
     * `STAFF_CREDENTIALS_INVALID`inden AYRI bir kod: ikisi farklı yüzeylerdir,
     * ayrımdan sonra farklı TABLOLARDIR ve istemci metinleri (birinde "panel",
     * diğerinde "uygulama") ayrışır; aynı koda bindirmek panelin varlığını ürün
     * ekranına taşırdı.
     *
     * ŞİFRE SIFIRLAMA da bu kodu KULLANMAZ: orada başarısızlık KODUN kendisidir
     * (`OTP_INVALID`), şifrenin değil.
     */
    CREDENTIALS_INVALID: 'CREDENTIALS_INVALID',
    // OAuth (Story 1.2)
    OAUTH_TOKEN_INVALID: 'OAUTH_TOKEN_INVALID',
    OAUTH_EMAIL_UNVERIFIED: 'OAUTH_EMAIL_UNVERIFIED',
    OAUTH_PROVIDER_NOT_CONFIGURED: 'OAUTH_PROVIDER_NOT_CONFIGURED',
    // Oturum / kimlik bağlantısı (Story 1.2 / 1.3)
    SESSION_NOT_FOUND: 'SESSION_NOT_FOUND',
    IDENTITY_NOT_FOUND: 'IDENTITY_NOT_FOUND',
    IDENTITY_LAST_LOGIN_METHOD: 'IDENTITY_LAST_LOGIN_METHOD',
    IDENTITY_ALREADY_LINKED: 'IDENTITY_ALREADY_LINKED',
    // Etkinlik / katılım (Blok 3+ kullanır, sözlük baştan tanımlı)
    EVENT_NOT_FOUND: 'EVENT_NOT_FOUND',
    EVENT_NOT_PUBLISHED: 'EVENT_NOT_PUBLISHED',
    EVENT_CANCELLED: 'EVENT_CANCELLED',
    EVENT_ACCESS_MODE_INVALID: 'EVENT_ACCESS_MODE_INVALID',
    EVENT_CAPACITY_EXCEEDED: 'EVENT_CAPACITY_EXCEEDED',
    /**
     * Kredi türünden gelen katılımcı tavanına ulaşıldı (V18 sert sınır, kullanıcı
     * kararı 01.10.2026): kayıt, davet kabulü ve başvuru onayı reddedilir. Katılımcı
     * "kontenjan doldu" görür; gövde tavanı ya da kredi türünü TAŞIMAZ (V17).
     */
    EVENT_ATTENDEE_CEILING_REACHED: 'EVENT_ATTENDEE_CEILING_REACHED',
    // Etkinlik sonu raporu (25.10.2026): bitmemiş 409 · iptal 409 (boş hâl) · sponsor 403.
    EVENT_REPORT_NOT_READY: 'EVENT_REPORT_NOT_READY',
    EVENT_REPORT_EVENT_CANCELLED: 'EVENT_REPORT_EVENT_CANCELLED',
    EVENT_REPORT_SPONSOR_FORBIDDEN: 'EVENT_REPORT_SPONSOR_FORBIDDEN',
    /**
     * Yayın için kredi yok ve etkin Kurumsal sözleşme yok (Story D2). Gövde
     * `nextAction: 'contact_sales'` taşır; yayındaki etkinlikler etkilenmez.
     */
    CREDIT_EXHAUSTED: 'CREDIT_EXHAUSTED',
    /**
     * Panelde aynı adla (büyük/küçük harf duyarsız, pasif kodlar dahil) ikinci
     * referans kodu oluşturuldu (referans kodu kapsamı · Story 1). Yalnız
     * `staff:credit_manage` taşıyan personel görür; kurum yüzeyinde kod adının
     * varlığını söyleyen hiçbir yanıt yoktur.
     */
    REFERRAL_CODE_NAME_TAKEN: 'REFERRAL_CODE_NAME_TAKEN',
    /**
     * Panel kredi yüklemesinde hediye kodu (referans kodu kapsamı · Story 4).
     * Yalnız `staff:credit_manage` taşıyan personel görür; kurum yüzeyinde kodun
     * geçerliliğini söyleyen hiçbir yanıt yoktur (kâhin yok, soru 7).
     * `NOT_FOUND` 400'dür ve `referralCode` alan hatası taşır (kod düzeltilir ya
     * da alan boşaltılır); diğerleri 409'dur ve İŞLEMİN TAMAMI yazılmaz: ödenen
     * hak da, hediye hakkı da, kullanım kaydı da.
     */
    REFERRAL_CODE_NOT_FOUND: 'REFERRAL_CODE_NOT_FOUND',
    REFERRAL_CODE_INACTIVE: 'REFERRAL_CODE_INACTIVE',
    REFERRAL_CODE_NOT_STARTED: 'REFERRAL_CODE_NOT_STARTED',
    REFERRAL_CODE_EXPIRED: 'REFERRAL_CODE_EXPIRED',
    REFERRAL_CODE_CAP_REACHED: 'REFERRAL_CODE_CAP_REACHED',
    REFERRAL_CODE_ALREADY_USED: 'REFERRAL_CODE_ALREADY_USED',
    EVENT_INVALID_STATE: 'EVENT_INVALID_STATE',
    EVENT_DATE_IN_PAST: 'EVENT_DATE_IN_PAST',
    EVENT_HAS_ATTENDEES: 'EVENT_HAS_ATTENDEES',
    EVENT_SHADOW_MODE_LOCKED: 'EVENT_SHADOW_MODE_LOCKED',
    /**
     * Karar 1 — kapı BELİRSİZLİKTE KAPANIR: kurumu OLMAYAN etkinlik `public`/
     * `approval` yayımlayamaz. CLAUDE.md "etkinlik HER ZAMAN bir Organization
     * altında" der; kural doğrulanamıyorsa ATLANMAZ, reddedilir (Blok 17C fix).
     */
    EVENT_ORGANIZATION_REQUIRED: 'EVENT_ORGANIZATION_REQUIRED',
    /**
     * KONUM ZORUNLU (kullanıcı kararı 14.10.2026): yüz yüze/hibrit etkinlik
     * haritada seçilmiş konum olmadan yayınlanamaz, yayındaki etkinliğin konumu
     * kaldırılamaz. Gövde `venue.geo` alan hatasını taşır. Harita kapatma
     * anahtarı kapalıyken bu kod HİÇ doğmaz (`isVenueGeoRequired`).
     */
    EVENT_VENUE_GEO_REQUIRED: 'EVENT_VENUE_GEO_REQUIRED',
    /** "Haritada bul": dış servis zaman aşımı, hata ya da ortak kuyruk dolu (harita Story 1). */
    VENUE_SEARCH_UNAVAILABLE: 'VENUE_SEARCH_UNAVAILABLE',
    /** "Haritada bul" sunucu ayarıyla kapalı (R6); istemci düğmeyi zaten çizmez. */
    VENUE_SEARCH_DISABLED: 'VENUE_SEARCH_DISABLED',
    EMAIL_NOT_VERIFIED: 'EMAIL_NOT_VERIFIED',
    TICKET_QUOTA_EXCEEDED: 'TICKET_QUOTA_EXCEEDED',
    TICKET_CLOSED: 'TICKET_CLOSED',
    TICKET_NOT_FOUND: 'TICKET_NOT_FOUND',
    TICKET_QUOTA_BELOW_RESERVED: 'TICKET_QUOTA_BELOW_RESERVED',
    TICKET_CAPACITY_EXCEEDED: 'TICKET_CAPACITY_EXCEEDED',
    ALREADY_REGISTERED: 'ALREADY_REGISTERED',
    REGISTRATION_NOT_FOUND: 'REGISTRATION_NOT_FOUND',
    /**
     * KAPI YALNIZ ETKİNLİK GÜNÜ AÇIKTIR (elle test 2 · bulgu 3). Erken/geç
     * okutma reddedilir; pencere etkinliğin KENDİ saat dilimindeki takvim
     * günleridir (`checkInWindowState`). Arayüz düğmeyi kapatır, KARAR burada.
     */
    CHECK_IN_NOT_OPEN: 'CHECK_IN_NOT_OPEN',
    /**
     * KAPI SONUCU AYRIŞIR (K3 · TW6): yaka kartı kodu BU etkinliğe ait ama kayıt
     * iptal edilmiş / reddedilmiş / silinmiş. Görevli "kod tanınmadı" yerine
     * nedenini görür. Yalnız etkinliği yöneten çağırır (`getManageableEvent`).
     */
    CHECK_IN_REGISTRATION_CANCELLED: 'CHECK_IN_REGISTRATION_CANCELLED',
    /**
     * Kod BAŞKA bir etkinliğin yaka kartı. Hangi etkinlik olduğu DÖNMEZ: başka
     * kurumun (belki `invite_only`) etkinliğinin adı kapı görevlisine sızmaz.
     * Jeton 32 karakter rastgeledir, yokluk/varlık bilgisi tahminle elde edilemez.
     */
    CHECK_IN_OTHER_EVENT: 'CHECK_IN_OTHER_EVENT',
    /**
     * Blok 17B: BİTMİŞ etkinlikte katılım YAZMALARI kapalıdır. Katılım geçmişi
     * öneri motorunun hafızasıdır (CLAUDE.md) — bitmiş etkinlikten çıkmak onu siler.
     */
    EVENT_ALREADY_ENDED: 'EVENT_ALREADY_ENDED',
    /**
     * KARAR 2 (kullanıcı, elle test 2): etkinliği YÖNETEN kişi kendi etkinliğine
     * kaydolamaz/başvuramaz. Organizatörün koltuğu yayın anında otomatik açılır
     * (`ensureOrganizerAttendanceTx`); katılımcı kulvarı ona kapalıdır. Kapı
     * SUNUCUDADIR — arayüzde düğmeyi gizlemek yetmez (Blok 17B bulgu D dersi).
     */
    EVENT_ORGANIZER_CANNOT_JOIN: 'EVENT_ORGANIZER_CANNOT_JOIN',
    APPLICATION_ALREADY_SUBMITTED: 'APPLICATION_ALREADY_SUBMITTED',
    APPLICATION_NOT_FOUND: 'APPLICATION_NOT_FOUND',
    APPLICATION_ALREADY_DECIDED: 'APPLICATION_ALREADY_DECIDED',
    // Organizasyon (Story 3.6)
    ORGANIZATION_NOT_FOUND: 'ORGANIZATION_NOT_FOUND',
    ORGANIZATION_MEMBER_NOT_FOUND: 'ORGANIZATION_MEMBER_NOT_FOUND',
    ORGANIZATION_MEMBER_EXISTS: 'ORGANIZATION_MEMBER_EXISTS',
    ORGANIZATION_OWNER_REQUIRED: 'ORGANIZATION_OWNER_REQUIRED',
    /**
     * Sahip kurumdan ayrılamaz: önce sahipliği başka bir AKTİF üyeye devretmeli
     * (tech-lead Y-1). Kurum sahipsiz kalmasın diye kapı MADDE 24'ten sonra da
     * YERİNDE — ama artık kimseyi kilitlemiyor: çoklu kurum üyeliği açık olduğu
     * için sahip, kurumundan ayrılmadan başka kurumlara katılabilir.
     */
    ORGANIZATION_OWNER_CANNOT_LEAVE: 'ORGANIZATION_OWNER_CANNOT_LEAVE',
    /**
     * Yönetici ya da sahip KENDİ satırını ekipten çıkarma ucuyla düşüremez
     * (409, üyelik yazma yolları turu 12.10.2026). Kendi isteğiyle ayrılmanın
     * yolu ayrılma ucudur (`DELETE /organizations/:id/members/me`): tek sahip
     * kuralı orada uygulanır ve çıkarma ucu o kuralın etrafından dolaşamaz.
     */
    ORGANIZATION_MEMBER_SELF_REMOVE: 'ORGANIZATION_MEMBER_SELF_REMOVE',
    /**
     * Personel kapağı kaldırmak istedi ama kurumun bağlı kapağı yok (409, kurum
     * kapağı · Story P1). Satır yazılmaz, dosya işi açılmaz, deftere girilmez.
     */
    ORGANIZATION_COVER_NOT_SET: 'ORGANIZATION_COVER_NOT_SET',
    /**
     * Personelin gördüğü kapak bu arada değişti (409, Story P1): sahip yeni kapak
     * bağladı ya da başka bir personel kaldırdı. Personelin görmediği görsel
     * kaldırılmaz; panel detayı yeniden yükler.
     */
    ORGANIZATION_COVER_CHANGED: 'ORGANIZATION_COVER_CHANGED',
    /**
     * Davet iptali yalnız BEKLEYEN davete uygulanır (409). İstek uçarken davet
     * kabul edildiyse satır artık aktif bir üyedir ve iptal onu ÇIKARMAZ:
     * çıkarma ayrı bir karardır ve ekip listesinden ayrıca verilir.
     */
    ORGANIZATION_INVITATION_ALREADY_ACCEPTED: 'ORGANIZATION_INVITATION_ALREADY_ACCEPTED',
    /**
     * Sahiplik YAŞAYAN bir hesaba devredilir (tech-lead 2 · Yüksek).
     *
     * KVKK purge üyelik SATIRINI silmez: `organization_members` aktif kalır,
     * yalnız kullanıcının adı/e-postası anonimleşir. Bu kapı olmadan sahiplik
     * silinmiş (ya da askıya alınmış) bir hesaba geçebiliyordu — o kurumda bir
     * daha ASLA sahip değişmez ve kimse ayrılamaz; KARAR 1'in çıkış yolu
     * KALICI olarak kapanır ve geri dönüşü yoktur.
     */
    ORGANIZATION_TRANSFER_TARGET_UNAVAILABLE: 'ORGANIZATION_TRANSFER_TARGET_UNAVAILABLE',
    /**
     * Kurum yetkisi KİŞİSEL hesaba yazılamaz (K1 QA P2 · kural 2 · KH14).
     *
     * Eski karma üyelik satırı yerinde kalabilir ama rol değişikliği ya da
     * sahiplik devri onu yetkili kılamaz: hesap türü değişmez olduğu için bu
     * satır hiçbir zaman yönetim yetkisi taşıyamaz. Ekip listesinde görünmez ve
     * aynı adrese yeniden davet de bu kodu alır (409): adres kişisel hesabındır,
     * çıkış yolu kişiyi kurum hesabının iş adresiyle davet etmektir.
     */
    ORGANIZATION_MEMBER_PERSONAL_ACCOUNT: 'ORGANIZATION_MEMBER_PERSONAL_ACCOUNT',
    /**
     * Madde 24 · 4. kalem: kurumun adı DOĞRULANMIŞ bir kurumun adına çok yakın.
     * Kurum kurulabilir; YAYIN ve AD DEĞİŞTİRME kapanır. Çıkış yolu doğrulamadır.
     */
    ORGANIZATION_NAME_CONFLICT: 'ORGANIZATION_NAME_CONFLICT',
    /**
     * KENDİ BAŞINA KURUM AÇMA KAPALI (kullanıcı kararı 01.10.2026 · Story A1).
     * Kurum satış görüşmesinden sonra panelden açılır; yanıt gövdesi
     * `nextAction: 'contact_sales'` taşır ve istemci "bize ulaşın" formuna yönlenir.
     * Kapı sunucu ayarıyla açılabilir (varsayılan kapalı), kod silinmedi.
     */
    ORGANIZATION_SELF_SERVE_DISABLED: 'ORGANIZATION_SELF_SERVE_DISABLED',
    /**
     * Sahip daveti bu işleme uygun durumda değil (Story C1): sahip daveti zaten
     * kabul edilmiş, ya da kurumun zaten bekleyen/etkin bir sahibi var. Kurum
     * hiçbir anda iki sahip satırı taşımaz.
     */
    ORGANIZATION_OWNER_INVITATION_CONFLICT: 'ORGANIZATION_OWNER_INVITATION_CONFLICT',
    /** Aynı anda tek AÇIK başvuru olabilir (`uq_org_verification_open`). */
    ORGANIZATION_VERIFICATION_ALREADY_OPEN: 'ORGANIZATION_VERIFICATION_ALREADY_OPEN',
    ORGANIZATION_VERIFICATION_REQUEST_NOT_FOUND: 'ORGANIZATION_VERIFICATION_REQUEST_NOT_FOUND',
    /** Karara bağlanmış başvuru yeniden karara bağlanamaz. */
    ORGANIZATION_VERIFICATION_ALREADY_DECIDED: 'ORGANIZATION_VERIFICATION_ALREADY_DECIDED',
    /** Belge silinmiş (90 gün) ya da hiç yüklenmemiş. */
    ORGANIZATION_VERIFICATION_DOCUMENT_UNAVAILABLE: 'ORGANIZATION_VERIFICATION_DOCUMENT_UNAVAILABLE',
    // Davet
    INVITATION_NOT_FOUND: 'INVITATION_NOT_FOUND',
    INVITATION_EXPIRED: 'INVITATION_EXPIRED',
    INVITATION_REVOKED: 'INVITATION_REVOKED',
    INVITATION_EMAIL_MISMATCH: 'INVITATION_EMAIL_MISMATCH',
    /**
     * Kurum daveti KİŞİSEL bir hesaba kayıtlı adrese gelmiş (KH8, kullanıcı kararı
     * 02.10.2026). Kurum üyeliği yalnız kurum hesabına yazılır, kabul reddedilir,
     * davet `invited` kalır. Kişisel hesabın adresi değiştirilemez (31.08 kararı).
     */
    INVITATION_EMAIL_IN_PERSONAL_ACCOUNT: 'INVITATION_EMAIL_IN_PERSONAL_ACCOUNT',
    INVITATION_ALREADY_USED: 'INVITATION_ALREADY_USED',
    // Sahiplenme
    CLAIM_INVALID_TRANSITION: 'CLAIM_INVALID_TRANSITION',
    CLAIM_ALREADY_OPEN: 'CLAIM_ALREADY_OPEN',
    CLAIM_NOT_FOUND: 'CLAIM_NOT_FOUND',
    CLAIM_EVENT_NOT_CLAIMABLE: 'CLAIM_EVENT_NOT_CLAIMABLE',
    CLAIM_SELF_CLAIM: 'CLAIM_SELF_CLAIM',
    CLAIM_EVIDENCE_REQUIRED: 'CLAIM_EVIDENCE_REQUIRED',
    CLAIM_OBJECTION_WINDOW_CLOSED: 'CLAIM_OBJECTION_WINDOW_CLOSED',
    /** İtiraz penceresi dolmadan (sahip onayı da yokken) onay verilemez. */
    CLAIM_OBJECTION_WINDOW_OPEN: 'CLAIM_OBJECTION_WINDOW_OPEN',
    // Kart / karşılaşma
    CARD_NOT_FOUND: 'CARD_NOT_FOUND',
    /**
     * Kırmızı çizgi 1'in yüzeye çıkan hâli: veritabanı tek onaylı karşılaşma
     * satırını reddetti. Normal akışta ASLA görülmez — servis iki onayı görmeden
     * yazmayı denemez. Görülürse kapıda değil KODDA bir kusur var demektir.
     */
    ENCOUNTER_CONSENT_REQUIRED: 'ENCOUNTER_CONSENT_REQUIRED',
    /**
     * Cüzdan kaydı yok, ya da ÇAĞIRANIN kaydı değil (Blok 23). İki durum TEK koda
     * iner: "var ama senin değil" demek, başkasının karşılaşmasının VARLIĞINI
     * doğrulamak olurdu (IDOR sızıntısının bilgi hâli).
     */
    ENCOUNTER_NOT_FOUND: 'ENCOUNTER_NOT_FOUND',
    // Kart değişimi teklifi (Faz 3 — Blok 20)
    //
    // DİKKAT: "jeton yok / kod yanlış / süresi dolmuş jeton / karşı taraf
    // erişilemez" için BU KÜMEDEN HİÇBİR KOD KULLANILMAZ — hepsi genel
    // `NOT_FOUND` ve 404 döner (Story 17.3: geçersiz kod ile var olmayan kod
    // ayırt edilemez). Buradaki kodlar yalnız ÇAĞIRANIN KENDİ durumunu anlatır.
    CARD_EXCHANGE_SELF: 'CARD_EXCHANGE_SELF',
    /**
     * BLOK 21 — AYIRT EDILEMEZ RET (kabul kriteri). Bes ayri sebep TEK koda
     * indirgenir: gecersiz/suresi dolmus jeton · var olmayan kisa kod · kaba
     * kuvvet kilidi · karsi taraf ulasilamaz (engel/askiya alma/silme) · teklif
     * reddedildi/iptal edildi/suresi doldu/size ait degil.
     *
     * `CARD_EXCHANGE_EXPIRED` ve `CARD_EXCHANGE_ALREADY_DECIDED` KALDIRILDI:
     * ikisi de karsi tarafin KARARINI ele veriyordu ("reddetti" ile "sure doldu"
     * ayirt edilebiliyordu). Yerine gecen metin ikisini de karsilar ve eylem
     * onerir; gerekce raporda.
     */
    CARD_EXCHANGE_UNAVAILABLE: 'CARD_EXCHANGE_UNAVAILABLE',
    // Medya
    MEDIA_TYPE_NOT_ALLOWED: 'MEDIA_TYPE_NOT_ALLOWED',
    MEDIA_TOO_LARGE: 'MEDIA_TOO_LARGE',
    MEDIA_NOT_FOUND: 'MEDIA_NOT_FOUND',
    /**
     * Görsel hâlâ bir kayıtta (profil fotoğrafı, kurum logosu, etkinlik kapağı…) kullanılıyor;
     * sahibinin `DELETE /media/:id` isteği reddedilir (409). Önce alan değiştirilir ya da
     * kaldırılır; eski görsel o zaman sunucuda kendiliğinden silinir (15.10.2026).
     */
    MEDIA_IN_USE: 'MEDIA_IN_USE',
    MEDIA_UPLOAD_FAILED: 'MEDIA_UPLOAD_FAILED',
    /**
     * Marka logosu asgari ölçüyü karşılamıyor (Story 23.1/23.3). Eşik TÜRE
     * BAĞLIDIR (kurum 256×256 kare · etkinlik 240×80 bant) ve mesaj bu yüzden
     * sayı YAZMAZ — alanın altındaki cümle o ekranın kendi eşiğini söyler.
     */
    MEDIA_DIMENSIONS_TOO_SMALL: 'MEDIA_DIMENSIONS_TOO_SMALL',
    /** Görsel yüklendi ama ölçüsü henüz işlenmedi; markaya bağlanamaz. */
    MEDIA_UPLOAD_INCOMPLETE: 'MEDIA_UPLOAD_INCOMPLETE',
    // Rıza
    CONSENT_REQUIRED: 'CONSENT_REQUIRED',
    // İlgi etiketi (Story 2.2)
    TAG_NOT_FOUND: 'TAG_NOT_FOUND',
    TAG_MERGE_INVALID: 'TAG_MERGE_INVALID',
    // Kart (Story 2.1/2.3)
    CARD_LIMIT_EXCEEDED: 'CARD_LIMIT_EXCEEDED',
    CARD_DEFAULT_REQUIRED: 'CARD_DEFAULT_REQUIRED',
    // Konuşmacı ve ajanda (Story 6.1/6.2 — Blok 5)
    SPEAKER_NOT_FOUND: 'SPEAKER_NOT_FOUND',
    SPEAKER_HAS_SESSIONS: 'SPEAKER_HAS_SESSIONS',
    SPEAKER_LINK_NOT_PENDING: 'SPEAKER_LINK_NOT_PENDING',
    SPEAKER_ALREADY_LINKED: 'SPEAKER_ALREADY_LINKED',
    AGENDA_SESSION_NOT_FOUND: 'AGENDA_SESSION_NOT_FOUND',
    AGENDA_TIME_CONFLICT: 'AGENDA_TIME_CONFLICT',
    /** Oturum etkinliğin başlangıç-bitiş aralığının dışında (elle test B-10). */
    AGENDA_SESSION_OUTSIDE_EVENT: 'AGENDA_SESSION_OUTSIDE_EVENT',
    // Katılımcı listesi (Story 7.2 — Blok 5)
    ATTENDEE_LIST_REQUIRES_REGISTRATION: 'ATTENDEE_LIST_REQUIRES_REGISTRATION',
    // Veri dışa aktarma (Story 8.3 — Blok 5)
    EXPORT_NOT_FOUND: 'EXPORT_NOT_FOUND',
    EXPORT_NOT_READY: 'EXPORT_NOT_READY',
    EXPORT_LINK_EXPIRED: 'EXPORT_LINK_EXPIRED',
    EXPORT_LINK_USED: 'EXPORT_LINK_USED',
    // Hesap silme (Story 8.4 — Blok 5)
    DELETION_ALREADY_REQUESTED: 'DELETION_ALREADY_REQUESTED',
    DELETION_NOT_REQUESTED: 'DELETION_NOT_REQUESTED',
    DELETION_BLOCKED_SOLE_OWNER: 'DELETION_BLOCKED_SOLE_OWNER',
    // Admin moderasyon (Epic 11 — Blok 6)
    USER_NOT_FOUND: 'USER_NOT_FOUND',
    SUSPEND_NOT_ALLOWED: 'SUSPEND_NOT_ALLOWED',
    USER_ALREADY_SUSPENDED: 'USER_ALREADY_SUSPENDED',
    USER_NOT_SUSPENDED: 'USER_NOT_SUSPENDED',
    MODERATION_ITEM_NOT_FOUND: 'MODERATION_ITEM_NOT_FOUND',
    MODERATION_ALREADY_DECIDED: 'MODERATION_ALREADY_DECIDED',
    MODERATION_CLAIM_DECIDED_IN_CLAIM_FLOW: 'MODERATION_CLAIM_DECIDED_IN_CLAIM_FLOW',
    // Görüşme talebi (Epic 12 — Blok 11)
    //
    // DİKKAT: "alıcı görünmüyor / talep yüzeyini kapatmış / engellemiş / hesabı yok"
    // için BU KÜMEDEN HİÇBİR KOD KULLANILMAZ — o durumlarda genel `NOT_FOUND` ve 404
    // döner, hiç var olmayan kullanıcıyla birebir aynı yanıt (kırmızı çizgi 2).
    MEETING_REQUIRES_ATTENDANCE: 'MEETING_REQUIRES_ATTENDANCE',
    MEETING_REQUEST_NOT_FOUND: 'MEETING_REQUEST_NOT_FOUND',
    MEETING_REQUEST_ALREADY_OPEN: 'MEETING_REQUEST_ALREADY_OPEN',
    MEETING_REQUEST_DECLINED_BEFORE: 'MEETING_REQUEST_DECLINED_BEFORE',
    MEETING_OPEN_REQUEST_LIMIT_REACHED: 'MEETING_OPEN_REQUEST_LIMIT_REACHED',
    MEETING_INVALID_TRANSITION: 'MEETING_INVALID_TRANSITION',
    MEETING_SLOT_CONFLICT: 'MEETING_SLOT_CONFLICT',
    MEETING_SLOT_INVALID: 'MEETING_SLOT_INVALID',
    MEETING_SLOT_NOT_FOUND: 'MEETING_SLOT_NOT_FOUND',
    /** Kendini engelleme (Blok 12). Yeniden engelleme HATA DEĞİLDİR: idempotenttir. */
    MEETING_BLOCK_INVALID: 'MEETING_BLOCK_INVALID',
    /** Çağıran alıcıyı ENGELLEMİŞ — kendi durumu, alıcıya dair sinyal taşımaz. */
    MEETING_BLOCKED_BY_YOU: 'MEETING_BLOCKED_BY_YOU',
    // --- Görüşme alanları (Story 13.2 — organizatör kürasyonu, Blok 14) ------
    MEETING_AREA_NOT_FOUND: 'MEETING_AREA_NOT_FOUND',
    MEETING_AREA_NAME_TAKEN: 'MEETING_AREA_NAME_TAKEN',
    /** Seçilen saat alanın uygunluk penceresi dışında. */
    MEETING_AREA_UNAVAILABLE: 'MEETING_AREA_UNAVAILABLE',
    /** Alanın eşzamanlı kapasitesi o saatte dolu (kabul anında ölçülür). */
    MEETING_AREA_FULL: 'MEETING_AREA_FULL',
    /**
     * ORGANİZATÖR yolu: kabul edilmiş görüşmeler hedef alanın kapasitesine
     * sığmıyor (taşıma) ya da yeni kapasite mevcut kabulleri kesiyor.
     */
    MEETING_AREA_CAPACITY_CONFLICT: 'MEETING_AREA_CAPACITY_CONFLICT',
    /**
     * ORGANİZATÖR yolu: kabul edilmiş görüşmeler hedef/yeni uygunluk penceresinin
     * dışında kalıyor — sessizce bozmak yerine açık hata.
     */
    MEETING_AREA_WINDOW_CONFLICT: 'MEETING_AREA_WINDOW_CONFLICT',
    /**
     * Paket tavanı (Faz 4 · Story 21.2). YALNIZCA ORGANİZATÖRÜN gördüğü yüzeylerde
     * doğar (davet gönderimi, toplu işlem). Katılımcı yazma yolları bu kodu ASLA
     * döndürmez: tavana ulaşan kayıt `EVENT_ATTENDEE_CEILING_REACHED` alır (V18) ve
     * paketin varlığı katılımcıya sızmaz. Check-in tavandan etkilenmez (P2).
     */
    PLAN_LIMIT_EXCEEDED: 'PLAN_LIMIT_EXCEEDED',
    /** Organizatör duyuruları (Story 1, 2, 9): ayrı dosyada (dosya tavanı, T2a). */
    ...error_codes_announcements_1.ANNOUNCEMENT_ERROR_CODES,
    ...error_codes_post_event_1.POST_EVENT_ERROR_CODES,
};
// Hata gövdesi tipleri ayrı dosyada (dosya tavanı). Tüketiciler buradan almaya devam eder.
__exportStar(require("./api-error-body"), exports);
//# sourceMappingURL=error-codes.js.map